'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue } from 'jotai/index';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import ListingBudgetFilter from '@/features/listing/components/listings-filters/listing-budget-filter/listing-budget-filter';
import ListingDetailedFilters from '@/features/listing/components/listings-filters/listing-detailed-filters/listing-detailed-filters';
import ListingSort from '@/features/listing/components/listings-filters/listing-sort/listing-sort';
import ListingTypeFilter from '@/features/listing/components/listings-filters/listing-type-filter/listing-type-filter';
import ListingViewSelect from '@/features/listing/components/listings-filters/listing-view-select/listing-view-select';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import { isBannerClosedAtom } from '@/features/roomster-app/atoms/is-banner-closed-atom';
import { usePathname } from '@/i18n/routing';
import styles from './listings-filters.module.scss';
export default function ListingsFilters() {
  const $ = _c(27);
  const [activeFilter, setActiveFilter] = useState(null);
  const isBannerClosed = useAtomValue(isBannerClosedAtom);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t0;
  if ($[0] !== searchParams) {
    t0 = new URLSearchParams(searchParams.toString());
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname || $[3] !== t0) {
    t1 = {
      pathname,
      searchParams: t0
    };
    $[2] = pathname;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [filterLink, setFilterLink] = useState(t1);
  let t2;
  let t3;
  if ($[5] !== pathname || $[6] !== searchParams) {
    t2 = () => {
      setFilterLink({
        pathname,
        searchParams: new URLSearchParams(searchParams.toString())
      });
    };
    t3 = [pathname, searchParams];
    $[5] = pathname;
    $[6] = searchParams;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  const t4 = activeFilter && styles.listingsFilters__isActive;
  const t5 = !isBannerClosed && styles.listingsFilters__withAppBanner;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = cx(styles.listingsFilters, t4, t5);
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.listingsFilters_item}><ListingViewSelect onFilterDisplayChange={setActiveFilter} /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== filterLink) {
    t8 = <div className={styles.listingsFilters_item}><ListingTypeFilter filterLink={filterLink} onFilterDisplayChange={setActiveFilter} /></div>;
    $[13] = filterLink;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== filterLink) {
    t9 = <div className={styles.listingsFilters_item}><ListingBudgetFilter filterLink={filterLink} setFilterLink={setFilterLink} onFilterDisplayChange={setActiveFilter} /></div>;
    $[15] = filterLink;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== filterLink) {
    t10 = <div className={styles.listingsFilters_item}><ListingDetailedFilters filterLink={filterLink} setFilterLink={setFilterLink} onFilterDisplayChange={setActiveFilter} /></div>;
    $[17] = filterLink;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== filterLink) {
    t11 = <div className={styles.listingsFilters_item}><ListingSort filterLink={filterLink} onFilterDisplayChange={setActiveFilter} /></div>;
    $[19] = filterLink;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t12 = <div className={t6}>{t7}{t8}{t9}{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}